import React from 'react';
import { TransactionsListPage } from 'src/solventpay/transactions/views/TransactionsListPage';

export function TransactionsPage() {
  // TransactionsListPage manages its own date picker when embedded in dashboard
  return (
    <TransactionsListPage
      showInlineHeader={true}
    />
  );
}
